import { de as t } from '../lang/authentication.json'
import router from '../router'
import { userService } from '../services'

// set initial user from localstorage - or null
const user = JSON.parse(localStorage.getItem('user'))
const initialState = user
    ? { status: { loggedIn: true }, user }
    : { status: {}, user: null }

export const authentication = {
    namespaced: true,
    state: initialState,
    actions: {
        login ({ dispatch, commit }, { username, password }) {
            userService.login(username, password).then(user => {
                commit('loginSuccess', user)
                router.push('/')
            }, error => {
                const errorResponseMessage = error.response.data.message
                let message = null

                switch (errorResponseMessage) {
                    case 'USER_NOT_FOUND':
                        message = t.userNotFound
                        break
                    case 'ACCOUNT_INACTIVE':
                        message = t.accountNotActivated
                        break
                    case 'USER_PASSWORD_INCORRECT':
                        message = t.authenticationFailed
                        break
                    default:
                        message = t.unkownError
                        break
                }

                commit('loginFailure', error)
                dispatch('alert/error', message, { root: true })
            })
        },
        logout ({ commit }) {
            // clear local storage
            localStorage.removeItem('user')
            localStorage.removeItem('token')
            // clear vuex state
            commit('logout')

            router.push('/login')
        },
        setRated ({ commit }) {
            commit('setRated')
        }
    },
    mutations: {
        loginSuccess (state, user) {
            state.status = { loggedIn: true }
            state.user = user
        },
        loginFailure (state) {
            state.status = {}
            state.user = null
        },
        logout (state) {
            state.status = {}
            state.user = null
        },
        setRated (state) {
            state.user.rating = state.user.rating || {}
            state.user.rating.ratedAt = new Date()
            localStorage.setItem('user', JSON.stringify(state.user))
        }
    }
}
